import React, { useEffect, useState } from "react";
import FleetUsageReportIcon from "assets/svgIcons/AdminDashboard/FleetUsageReportIcon";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { AmpHoursChart } from "../../../../commonComponents/Charts/AmpHoursChart";
import "hammerjs";
import "@progress/kendo-theme-default/dist/all.css";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const FleetUsageReports = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    getCarUsageState,
    getDashboardFeatureSetStatus,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getCarsData,
    getFaultsData,
  } = useSelector((state) => state?.commonReducers) || [];

  const [RefreshChart, setRefreshChart] = useState(true);

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null
    ) {
      dispatch(COMMON_SERVICES.getCarUsageServices(siteId.get(), true));
    }
  }, [getDashboardFeatureSetStatus, siteId.get()]);



  useEffect(() => {
    if (getCarUsageState?.length > 0) {
      setRefreshChart(true);
      setTimeout(() => setRefreshChart(false), 2000);
    }
  }, [getCarUsageState]);

  useEffect(() => {
    setRefreshChart(false);
  }, [getCarsData, getCurrentCarsData, getMessagesFromCarsData, getFaultsData]);

  const handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    if (RefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  return (
    <>
      <div className="header">
        <FleetUsageReportIcon />
        <p className="see-green-border">{t("Fleet_Usage_Reports")}</p>
      </div>
      <div className="box-body" style={{ padding: "60px 38px 38px" }}>
        <AmpHoursChart 
          data={getCarUsageState || []}
          onRefresh={handleChartRefresh}
          title="Amp_Hours"
          showTitle={true}
          includeZeros={false}
        />
      </div>
    </>
  );
};

export default FleetUsageReports;
